import axios from 'axios';
import type { OfferDetailsType } from './getOfferDetails';

const getOfferDetailsForCoop = async (
  appointmentId: string,
  listingId: string,
) => {
  const { data: fetchedOfferDetails } = await axios.get<OfferDetailsType>(
    `/user/coop/appointment/${appointmentId}/offer_details/${listingId}`,
  );
  return fetchedOfferDetails;
};

export default getOfferDetailsForCoop;
